import React from "react";
import ContentHeader from "../../components/ContentHeader/ContentHeader"; import { Condiciones } from "../../components/Condiciones/Condiciones";
import { Historico } from "../../components/HistoricoSolicitudes/Historico";
import { AddCircleOutline } from "@material-ui/icons";
import "./Dashboard.scss";
import { UltimasSolicitudes } from "../../components/UltimasSolicitudes/UltimasSolicitudes";
import { Link } from "react-router-dom";
import { CostInfoRedirect } from "../../components/Info/CostInfoRedirect";


export const Dashboard = () => {
    return (
        <div className="dashboard">
            <CostInfoRedirect />
            <ContentHeader titulo="Inicio" />
            <div className="container">
                <div className="button-solicitar-mobile col-12 mb-1">
                    <Link to="/search">
                        <button><AddCircleOutline className="AddCircleOutline" /> Solicitar eGrade</button>
                    </Link>
                </div>
                <div className="row g-0">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-5 my-4 historico-container">
                        <Historico />
                    </div>
                    <div className="col-12 col-sm-12 col-md-7 col-lg-4 col-xl-4 col-xxl-3 my-4 mb-sm-0">
                        <Condiciones />
                    </div>
                    <div className="button-solicitar col-sm-3 col-md-4 col-lg-4 ms-xl-4 ms-xxl-0 ms-sm-2 col-xxl-3 col-xl-2 mb-sm-5">
                        <Link to="/search">
                            <button><AddCircleOutline className="AddCircleOutline" /> Solicitar eGrade</button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row mt-2 gx-5">
                    <UltimasSolicitudes />
                </div>
            </div>
            <div className="d-flex align-items-end flex-column ">
                <div className="col-3 ver-todas-mobile">
                    <Link to="/request" style={{ textDecoration: 'none', color: '#5c157d' }}>
                        <p>Ver todas</p>
                    </Link>
                </div>
            </div>
        </div>
    )
}